import * as React from "react";

export type DeviceTier = "phone" | "tabletPortrait" | "tabletLandscape" | "terminal";

/** Width breakpoints for the UI pilot: <768 phone, <1024 portrait tablet, <1280 landscape tablet. */
export function tierForWidth(width: number): DeviceTier {
  if (width < 768) return "phone";
  if (width < 1024) return "tabletPortrait";
  if (width < 1280) return "tabletLandscape";
  return "terminal";
}

export function useDeviceTier(): DeviceTier {
  const [tier, setTier] = React.useState<DeviceTier>(() =>
    typeof window === "undefined" ? "terminal" : tierForWidth(window.innerWidth),
  );

  React.useEffect(() => {
    const onResize = () => setTier(tierForWidth(window.innerWidth));
    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return tier;
}
